export const lazyLoadImages = {
    methods: {
        lazyLoadImages: async function() {
            await this.$nextTick()
            const imageObserver = new IntersectionObserver(
                (entries, imgObserver) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const lazyImage = entry.target
                            const photoURL = lazyImage.dataset.src
                            imgObserver.unobserve(lazyImage)
                            this.preloadImage(photoURL).then(img => {
                                lazyImage.src = lazyImage.dataset.src
                                lazyImage.classList.remove("lzy_img")
                                lazyImage.classList.add("fade")
                            })
                        }
                    })
                }
            )

            const arr = document.querySelectorAll("img.lzy_img")
            arr.forEach(v => {
                imageObserver.observe(v)
            })
        },
        preloadImage(src) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.addEventListener("load", () => resolve(img))
                img.addEventListener("error", err => reject(err))
                img.src = src
            })
        }
    }
}
